/* eslint-disable global-require */
import i18n from "@/i18n/index";
import { getTaskStatus } from "@/components/tasks/myTeamsTasks/constants";

export const TASKS_STATUS = [
    {
        label: i18n.t("tasks.filterBy.overdue"),
        value: "OVERDUE",
        svgIcon: { name: getTaskStatus("OVERDUE") }
    },
    {
        label: i18n.t("tasks.filterBy.inWarning"),
        value: "AT_RISK",
        svgIcon: { name: getTaskStatus("AT_RISK") }
    },
    {
        label: i18n.t("tasks.filterBy.attention"),
        value: "ATTENTION",
        svgIcon: { name: getTaskStatus("ATTENTION") }
    },
    {
        label: i18n.t("tasks.filterBy.onTime"),
        value: "ON_TRACK",
        svgIcon: { name: getTaskStatus("ON_TRACK") }
    }
];

export const OPERATORS_VALUES = [
    {
        label: "==",
        value: "EQUAL",
        description: i18n.t("liveView.filters.dataModelOperators.equals")
    },
    {
        label: "!=",
        value: "NOT_EQUAL",
        description: i18n.t("liveView.filters.dataModelOperators.notEquals")
    },
    {
        label: "⊂",
        value: "CONTAINS",
        description: i18n.t("liveView.filters.dataModelOperators.contains")
    }
];

export const OPERATORS_BOOLEAN_VALUES = [
    {
        label: "==",
        value: "EQUAL",
        description: i18n.t("liveView.filters.dataModelOperators.equals")
    },
    {
        label: "!=",
        value: "NOT_EQUAL",
        description: i18n.t("liveView.filters.dataModelOperators.notEquals")
    }
];

export const OPERATORS_ALL_VALUES = [
    {
        label: "==",
        value: "EQUAL",
        description: i18n.t("liveView.filters.dataModelOperators.equals")
    },
    {
        label: "!=",
        value: "NOT_EQUAL",
        description: i18n.t("liveView.filters.dataModelOperators.notEquals")
    },
    {
        label: ">",
        value: "GREATER_THAN",
        description: i18n.t("liveView.filters.dataModelOperators.greater")
    },
    {
        label: ">=",
        value: "GREATER_THAN_OR_EQUAL",
        description: i18n.t("liveView.filters.dataModelOperators.greaterOrEqual")
    },
    {
        label: "<",
        value: "LOWER_THAN",
        description: i18n.t("liveView.filters.dataModelOperators.less")
    },
    {
        label: "<=",
        value: "LOWER_THAN_OR_EQUAL",
        description: i18n.t("liveView.filters.dataModelOperators.lessOrEqual")
    }
];

export const BOOLEAN_VALUES = [
    {
        value: "true",
        label: i18n.t("liveView.filters.dataModelOperators.true")
    },
    {
        value: "false",
        label: i18n.t("liveView.filters.dataModelOperators.false")
    }
];

export const TASKS_PRIORITY = [
    {
        label: i18n.t("liveView.filters.lowest"),
        value: "lowest",
        svgIcon: { name: require("@/assets/images/lowest_priority.svg"), size: "16px" }
    },
    {
        label: i18n.t("liveView.filters.low"),
        value: "low",
        svgIcon: { name: require("@/assets/images/low_priority.svg"), size: "16px" }
    },
    {
        label: i18n.t("liveView.filters.normal"),
        value: "normal",
        svgIcon: { name: require("@/assets/images/normal_priority.svg"), size: "16px" }
    },
    {
        label: i18n.t("liveView.filters.high"),
        value: "high",
        svgIcon: { name: require("@/assets/images/high_priority.svg"), size: "16px" }
    },
    {
        label: i18n.t("liveView.filters.highest"),
        value: "highest",
        svgIcon: { name: require("@/assets/images/highest_priority.svg"), size: "16px" }
    }
];

export const TASKS_INSTANCE_STATUS = [
    {
        label: i18n.t("admin.processInspector.runningStatus"),
        value: "RUNNING"
    },
    {
        label: i18n.t("admin.processInspector.completedStatus"),
        value: "COMPLETED"
    },
    {
        label: i18n.t("admin.processInspector.failedStatus"),
        value: "FAILED"
    }
];

export const EXPORT_MAPPINGS = {
    priority: "s_Task.priority",
    taskName: "s_Task.subject",
    instanceID: "s_ProcessInstance.id",
    assignment: "s_Task.assignee",
    creationDate: "s_Task.creationDateTime",
    creationSource: "s_CreationSource",
    deadline: "s_Task.deadline",
    status: "s_Task.status",
    instanceName: "s_ProcessInstance.name",
    startDate: "s_ProcessInstance.startDateTime",
    completionDate: "s_ProcessInstance.endDateTime",
    activity: "s_Activity.name",
    expiration: "s_Task.expiration",
    endActivityName: "s_ProcessInstance.endActivityName"
};

export const REFS_TO_RESET = [
    "resetStatusesData",
    "resetInstancesData",
    "resetAssigneesData",
    "resetActivitesData",
    "resetPriorityData"
];

export const REPORTS_FILTERS_DEFAULT = [
    {
        value: "search",
        visible: true,
        fieldValue: [{
            value: ""
        }],
        invisibleToUser: false
    },
    {
        value: "activity",
        visible: true,
        fieldValue: [{
            value: ""
        }],
        invisibleToUser: false
    },
    {
        value: "taskStatus",
        visible: true,
        fieldValue: [{
            value: []
        }],
        invisibleToUser: false
    },
    {
        value: "instanceStatus",
        visible: true,
        fieldValue: [{
            value: []
        }],
        invisibleToUser: false
    },
    {
        value: "fromDate",
        visible: true,
        fieldValue: [{
            value: ""
        }],
        invisibleToUser: false
    },
    {
        value: "toDate",
        visible: true,
        fieldValue: [{
            value: ""
        }],
        invisibleToUser: false
    },
    {
        value: "assignees",
        visible: true,
        invisibleToUser: false,
        fieldValue: [
            {
                filterType: "GROUP_IDS",
                value: []
            }, {
                filterType: "USER_IDS",
                value: []
            }
        ]
    },
    {
        value: "taskPriority",
        visible: true,
        fieldValue: [{
            value: []
        }],
        invisibleToUser: false
    }
];
